<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>月度收入对账</span>
        </div>
        <el-form :inline="true">
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="queryParams.startDate"
              placeholder="请选择日期"
              clearable
              value-format="yyyy-MM"
              type="month"
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="queryParams.endDate"
              placeholder="请选择日期"
              clearable
              value-format="yyyy-MM"
              type="month"
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
          <!--          <one-import :get-table="getTables" :import-method="importBill" />-->
        </el-form>
        <el-table
          :data="tableData"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          border
          :default-expand-all="false"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
            width="120"
          />
          <el-table-column
            prop="type"
            label="平台"
            align="center"
            width="120"
            :formatter="typeFormatter"
          />
          <el-table-column
            label="收入情况"
            align="center"
          >
            <el-table-column
              prop="price"
              label="后台流水"
              align="center"
              width="130"
            />
            <el-table-column
              prop="in_price"
              label="商店内购收入"
              align="center"
              width="130"
            />
            <el-table-column
              label="平台费率"
              align="center"
              width="130"
              :formatter="differFormatter"
            >
              <template scope="scope">
                <span v-if="scope.row.type ===0">-</span>
                <span v-else>{{ scope.row.tariff }}%</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="incomes"
              label="理论总收入"
              width="130"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="380"
                  trigger="hover"
                  content="理论收入=后台流水*（1-平台费率）+广告收入"
                >
                  <span slot="reference">理论收入 <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              prop="total_price"
              label="实际总收入"
              width="130"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="130"
                  trigger="hover"
                  content="实际总收入=广告收入+商店内购收入"
                >
                  <span slot="reference">总收入 <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="ad_price"
            label="广告收入"
            width="130"
            align="center"
          />
          <el-table-column
            prop="differ"
            label="结算相差金额"
            align="center"
            width="130"
          />
          <el-table-column
            prop="differ_rate"
            label="结算相差比例"
            align="center"
            width="130"
            :formatter="differFormatter"
          />
          <el-table-column
            label="银行应收款"
            align="center"
          >
            <el-table-column
              prop="platform_bank_price"
              label="平台银行收款"
              align="center"
              width="130"
            />
            <el-table-column
              label="广告银行收款"
              prop="ad_bank_price"
              align="center"
              width="130"
            >
              <template scope="scope">
                <template v-if="scope.row.type == 0">{{ scope.row.ad_bank_price }}</template>
                <template v-else>-</template>
              </template>
            </el-table-column>
            <el-table-column
              prop="bank_price"
              label="银行总收款"
              align="center"
              width="130"
            />
          </el-table-column>
          <el-table-column
            prop="status"
            label="确认状态"
            align="center"
            width="130"
          >
            <template scope="scope">
              <template v-if="scope.row.type == 0">
                <span v-if="scope.row.status < 2" style="color:#F56C6C">未确认</span>
                <span v-else style="color:#67C23A">已确认</span>
              </template>
              <template v-else>-</template>

            </template>
          </el-table-column>
          <el-table-column
            prop="confirm_price"
            label="确认金额($)"
            align="center"
            width="130"
          >
            <template scope="scope">
              <template v-if="scope.row.type != 0">
                -
              </template>
              <template v-else>
                <!--                <template v-if="scope.row.status<2">-->
                <el-button type="text" size="mini" @click="handleConfirmDialog(scope.row.id,scope.row.confirm_price)">$ {{ scope.row.confirm_price }}</el-button>
                <!--                </template>-->
                <!--                <template v-else>¥ {{ scope.row.confirm_price }}</template>-->
              </template>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="250"
          >
            <template scope="scope">
              <el-button v-if="scope.row.type == 0" :loading="loading" size="mini" type="primary" @click="handle(scope.row)">
                对账
              </el-button>

              <el-button v-if="scope.row.type == 0" :loading="loading" size="mini" type="primary" @click="handleAd(scope.row)">
                广告收入
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

      <el-card>
        <dataChart ref="echart" />
      </el-card>

      <el-drawer
        :before-close="handleClose"
        :visible.sync="drawer"
        :direction="direction"
      >
        <el-form>
          <el-card v-for="(item,index) in form.data" :key="index" class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ item.title }}</span>
            </div>

            <el-form-item label="费率(百分比)">
              <el-input v-model.trim="item.tariff" size="small" />
            </el-form-item>

            <el-form-item label="商店内购收入">
              <el-input v-model.trim="item.price" size="small" />
            </el-form-item>

            <!--            <el-form-item label="广告收入">-->
            <!--              <el-input v-model.trim="item.adPrice" size="small" />-->
            <!--            </el-form-item>-->
            <el-form-item label="平台银行收款">
              <el-input v-model.trim="item.platformBankPrice" size="small" />
            </el-form-item>
            <!--            <el-form-item label="广告银行收款">-->
            <!--              <el-input v-model.trim="item.adBankPrice" size="small" />-->
            <!--            </el-form-item>-->

          </el-card>

          <el-form-item style="margin-top: 10px;text-align: center">
            <el-button type="primary" :loading="loading" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>

      <el-drawer
        :before-close="handleClose"
        :visible.sync="drawerAd"
        :direction="direction"
        :close-on-click-modal="false"
      >
        <el-form>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>广告渠道对账</span>
            </div>

            <el-form-item label="ADMob">
              <el-input v-model.trim="formAd.admob" size="small" />
            </el-form-item>

            <el-form-item label="APPLovin">
              <el-input v-model.trim="formAd.applovin" size="small" />
            </el-form-item>

            <el-form-item label="Meta">
              <el-input v-model.trim="formAd.meta" size="small" />
            </el-form-item>

            <el-form-item label="Liftoff Monetize-vungle">
              <el-input v-model.trim="formAd.liftoff" size="small" />
            </el-form-item>

            <el-form-item label="Unity">
              <el-input v-model.trim="formAd.unity" size="small" />
            </el-form-item>

            <el-form-item label="IronSource">
              <el-input v-model.trim="formAd.ironsource" size="small" />
            </el-form-item>

          </el-card>

          <el-form-item style="margin-top: 10px;text-align: center">
            <el-button type="primary" @click="onSubmitAd">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>

      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <el-form>
          <el-form-item label="确认金额'">
            <el-input v-model.trim="confirm.price" size="small" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>
import { getAdIncomes, getBill, handleAdIncomes, handleBill } from '@/api/config/order'
// import OneImport from '@/components/oneImport/index.vue'
import dataChart from '@/views/config/bill/components/chat.vue'
export default {
  name: 'OrderBill',
  components: { dataChart },
  data() {
    return {
      loading: false,
      title: '',
      dialogVisible: false,
      drawer: false,
      drawerAd: false,
      direction: 'rtl',
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      },
      lock: false,
      confirm: {
        id: 0,
        price: 0
      },
      formAd: {
        date: '',
        admob: 0,
        applovin: 0,
        meta: 0,
        liftoff: 0,
        unity: 0,
        ironsource: 0
      },
      form: {
        date: '',
        data: [{
          title: '安卓',
          type: 1,
          tariff: 0,
          price: 0,
          adPrice: 0,
          adBankPrice: 0,
          platformBankPrice: 0
        },
        {
          title: '苹果',
          type: 2,
          tariff: 0,
          price: 0,
          adPrice: 0,
          adBankPrice: 0,
          platformBankPrice: 0
        }]
      },
      total: 0,
      tableData: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleAd(row) {
      this.formAd.date = row.date
      this.getAdIncomesData(row.date)
    },
    handle(row) {
      this.form.date = row.date
      for (const i in row.children) {
        const val = row.children[i]
        for (const k in this.form.data) {
          const _d = this.form.data[k]
          if (_d.type === val.type) {
            _d.tariff = val.tariff
            if (_d.tariff === 0) {
              _d.tariff = val.type === 1 ? 15 : 30
            }
            _d.price = val.in_price
            _d.bank_price = val.bank_price
            _d.adBankPrice = val.ad_bank_price
            _d.platformBankPrice = val.platform_bank_price
            _d.adPrice = val.ad_price
          }
          this.form.data[k] = _d
        }
      }
      this.drawer = true
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
      }
      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
      }
      this.getTables()
    },
    handleConfirmDialog(id, price) {
      this.confirm.id = id
      this.confirm.price = price
      this.dialogVisible = true
    },
    handleConfirm() {
      this.dialogVisible = false
      if (this.confirm.price <= 0) {
        this.msgError('金额有误！')
        return
      }
      const data = JSON.stringify(this.confirm)
      handleBill({ data: data }).then(res => {
        if (res.code === 200) {
          this.confirm = {
            id: 0,
            price: 0
          }
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.loading = true
      getBill(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          for (const i in res.data.list.list) {
            res.data.list.list[i].edit = false
          }
          this.tableData = res.data.list.list
          this.total = res.data.count
          this.queryParams.startDate = res.data.list.req.StartDate
          this.queryParams.endDate = res.data.list.req.EndDate
          this.$refs.echart.change(this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getAdIncomesData(date) {
      this.loading = true
      getAdIncomes({ date: date }).then(res => {
        this.loading = false
        if (res.data) {
          this.formAd = res.data
        }
        this.formAd.date = date
        this.drawerAd = true
      })
    },
    typeFormatter(row, col) {
      const typeMap = { 0: '所有', 1: '安卓', 2: '苹果', 5: 'TG' }
      return typeMap[row.type]
    }, differFormatter(row, col, val) {
      return val + '%'
    }, statusFormatter(row, col, val) {
      const typeMap = { 0: '未对账', 1: '对账中', 2: '已收款' }
      return typeMap[val]
    },
    onSubmitAd() {
      if (this.lock) {
        return
      }
      this.loading = true
      this.lock = true
      const data = JSON.stringify(this.formAd)
      handleAdIncomes({ data: data }).then(res => {
        this.loading = false
        this.lock = false
        if (res.code === 200) {
          this.drawerAd = false
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      if (this.lock) {
        return
      }
      this.lock = true
      this.drawer = false
      const _formData = this.form.data
      for (const i in _formData) {
        const val = _formData[i]
        for (const k in val) {
          if (k === 'title' || k === 'type') {
            continue
          }
          _formData[i][k] = parseFloat(val[k])
        }
      }
      this.form.data = _formData
      const data = JSON.stringify(this.form)
      handleBill({ data: data }).then(res => {
        this.lock = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
